import { __awaiter, __generator } from "tslib";
var AnalyticsNode = /** @class */ (function () {
    function AnalyticsNode() {
    }
    AnalyticsNode.load = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                throw new Error('AnalyticsNode is not available in browsers.');
            });
        });
    };
    return AnalyticsNode;
}());
export { AnalyticsNode };
//# sourceMappingURL=node.browser.js.map